<template>
  <InputText autofocus placeholder="Enter Folder Name" type="text" v-model="folderName" />
  <Button type="button" class="btn-primary" style="color: white;" @click="createFolder" :loading="loadingBtn">Create</Button>
</template>

<script setup>

import {computed, ref} from "vue";
import {useSlidesStore, useMainStore} from "@/store/index.ts";
import {storeToRefs} from "pinia";

const props = defineProps({
  parentFolder: {
    type: Object
  },
  space: {
    type: String
  }
})


const mainStore = useMainStore()
const {slideLibraryActive } = storeToRefs(mainStore)

const folderName = ref('')
const emit = defineEmits(['folder-created']);
const loadingBtn = ref(false)

const slidesStore = useSlidesStore()
const { valueModelId } = storeToRefs(slidesStore)

const computedRoutePath = computed(() => {
  return slideLibraryActive.value ? `?vmId=null` : `?vmId=${valueModelId.value}`;

});

const createFolder = async () => {
  loadingBtn.value = true
  try {
    await fetch(
        `${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/create-folder/${props.space}${computedRoutePath.value}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            parentId: props.parentFolder.id,
            folderName: folderName.value
          })
        })
    emit('folder-created')
    loadingBtn.value = false
  } catch {
    loadingBtn.value = false
    console.error('cannot create folder.')
  }
}

</script>
<style lang="scss" scoped>


input {
  width: 400px !important;
}
</style>
